import IProgramFailure from "../../../../../domain/core/failures/program/programFailure";
import { programFailures } from "../programFailures";

export function fromProgramFailureFirebaseMapper(message: string): IProgramFailure {
  let code = programFailures["SERVER_ERROR"];

  const programFailure: IProgramFailure = {
    code: code,
    message: message,
  };

  return programFailure;
}